module.exports = __webpack_public_path__ + "img/avatar.9b7428a3.png";